export { default as BarcodeScanner } from '../../components/BarcodeScanner.vue'
export { default as CartProduct } from '../../components/CartProduct.vue'
export { default as Category } from '../../components/Category.vue'
export { default as Footer } from '../../components/Footer.vue'
export { default as Header } from '../../components/Header.vue'
export { default as HistoryItem } from '../../components/HistoryItem.vue'
export { default as Loading } from '../../components/Loading.vue'
export { default as Modal } from '../../components/Modal.vue'
export { default as MyListItem } from '../../components/MyListItem.vue'
export { default as MyListItemPrice } from '../../components/MyListItemPrice.vue'
export { default as Product } from '../../components/Product.vue'
export { default as Template } from '../../components/Template.vue'

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
